import {InputSelect} from '@/components/commons/input-select/InputSelect'
import {ProjectFieldsSchema} from '@/features/projects/formSchemas'
import {rehabilitationFacilitiesMapToLabel} from '@/features/projects/utils'
import {useTranslation} from '@/translations/i18n'
import {useController, useFormContext} from 'react-hook-form'
import {z} from 'zod'

const ProjectPatientRehabilitationFacilitySchema = ProjectFieldsSchema.pick({
    rehabilitationFacility: true
})
type ProjectPatientRehabilitationFacilitySchema = z.infer<typeof ProjectPatientRehabilitationFacilitySchema>

export const ProjectPatientRehabilitationFacilityField = () => {
    const {t} = useTranslation()
    const {control} = useFormContext<ProjectPatientRehabilitationFacilitySchema>()
    const {field} = useController({control, name: 'rehabilitationFacility'})

    return (
        <InputSelect
            {...field}
            value={field.value ?? undefined}
            optionsMap={rehabilitationFacilitiesMapToLabel}
            onClear={() => field.onChange(null)}
            label={t('projects:patient_rehabilitation_facilities')}
        />
    )
}
